import { render, staticRenderFns } from "./OrganizationOwnerCard.vue?vue&type=template&id=1eba1276&scoped=true&lang=pug"
import script from "./OrganizationOwnerCard.vue?vue&type=script&lang=js"
export * from "./OrganizationOwnerCard.vue?vue&type=script&lang=js"
import style0 from "./OrganizationOwnerCard.vue?vue&type=style&index=0&id=1eba1276&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eba1276",
  null
  
)

export default component.exports